<template>
    <div class="common-module-page">
        <div class="page">
            <CommonTitle :title="modelTitle" :page-index="filterData.pageIndex" :page-size="filterData.pageSize" :total="total" @changePage="changePage"/>
            <ul class="excellent-lesson" v-if="realList.length" v-loading="loading">
                <li class="excellent-lesson-item" v-for="item in realList" :key="item.id" @click="toDetail(item.id)">
                    <div class="list-item-link" v-link="linkUrl(item.id)">
                        <div class="list-item-img">
                            <LazyImage :src="item.coverUrl" className="img" />
                            <div class="course-type" v-if="item.reviewType">
                                <img class="course-icon" v-if="item.reviewType==1" src="~@/assets/img/home/icon-record.png" alt="">
                                <img class="course-icon" v-if="item.reviewType==2" src="~@/assets/img/home/icon-live.png" alt="">
                                <img class="course-icon" v-if="item.reviewType==3" src="~@/assets/img/home/icon-site.png" alt="">
                                <div class="type-desc">{{courseType[item.reviewType]}}</div>
                            </div>
                        </div>
                        <div class="list-item-content">
                            <p class="title" :title="item.lessonName">
                                {{ item.lessonName }}
                            </p>
                            <div class="course-info flex-between">
                                <p class="teacher overflow-ellipsis" :title="`授课人：${item.lectureTeacherName}`">
                                    <span class="teacher-label">授课人：</span>{{item.lectureTeacherName}}
                                </p>
                                <div class="create-time">{{dayjs(item.gmtCreate).format('YYYY.MM.DD HH:mm')}}</div>
                            </div>
                            
                            
                        </div>
                    </div>
                </li>
            </ul>
            <BigNoData v-else class="no-data" url="no-lesson.png" info="暂无听评课" />
        </div>
    </div>
</template>
<script setup>
import CommonTitle from '@/components/home-common-title/common-index.vue'
import BigNoData from '@/components/no-data.vue'
import LazyImage from '@/components/lazy-image/lazy-image.vue';
import { ref, reactive, onMounted, computed } from 'vue';
import { useStore } from 'vuex'
import dayjs from 'dayjs';
import { pageJump } from '@/global/location-transfer'
import { jumpHref } from '@/router/jumpHref.js';

const props = defineProps({
    modelTitle: {
        type: String,
        default: ''
    }
})


const store = useStore()

const courseType = ['课例分析', '直播评课', '现场评课']
let total = ref(0);
const list = ref([]);

const loading = ref(false);
const filterData = reactive({
    pageSize: 4,
    pageIndex: 1,
    lessonType: 2, // 课程类型 1-听评课 2-案例
    // state: 1, // 启用状态 -1 删除 0：禁用，1：正常
    order: 0,
    bestState: 1 // 是否是优秀案例 0-不是 1-是
});
const realList = computed(() => {
    return list.value?.length && list.value.slice(0, 4) || [];
})

const getList = function () {
    loading.value = true;
    G_transmit('lessonSquare', {
        name: 'lessonSquare',
        data: {
            ...filterData
        }
    }).then(res => {
        list.value = res?.data?.rows || [];
        total.value = res?.data?.total || 0
    }).finally(() => {
        loading.value = false;
    });
}

const changePage = (pageIndex) => {
    console.log('pageIndex1', pageIndex)
    filterData.pageIndex = pageIndex
    getList();
}

// 跳转广场
function goSquare () {
    pageJump({name: 'videoCaseSquare'});
}

// 跳转案例详情
function toDetail(id) {
    pageJump(jumpHref.videocase.detail(id), true);
}

function linkUrl(id){
    return {
        url: jumpHref.videocase.detail(id),
        className: 'link-item'
    }
}

// 显示三个不重复的学科
function handleSubject (list) {
    let tempList = [];
    list && list.forEach(item => {
        item.subjectList && item.subjectList.forEach(item2 => {
            if (!tempList.includes(item2.subjectName) && tempList.length < 3) {
                tempList.push(item2.subjectName);
            }
        })
    })
    return tempList;
}

onMounted(() => {
     getList()
})

</script>

<style lang="scss" scoped>
.common-module-page {
    // width: 100vw;
    background: #FFFFFF;
    padding-bottom: 40px;
    .page {
        width: 1200px;
        margin: 0 auto;
    }
}
.excellent-lesson {
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    border-radius: 4px;
}

.excellent-lesson-item {
    box-sizing: border-box;
    width: 285px;
    // margin-top: 20px;
    margin-right: 20px;
    cursor: pointer;

    &:hover {
         box-shadow: 0px 1px 12px 0px rgba(0,0,0,0.1500);
         .list-item-content {
            border: none;
         }
    }

    &:nth-child(n+4) {
        margin-right: 0;
    }

    .list-item-img {
        width: 100%;
        height: 160px;
        position: relative;
        .img {
            width: 100%;
            height: 100%;
            border-radius: 4px 4px 0px 0px;
        }
        .course-type {
            position: absolute;
            width: 90px;
            height: 64px;
            top: 50%;
            left: 50%;
            margin-left: -45px;
            margin-top: -32px;
            background: #000000;
            border-radius: 8px;
            opacity: 0.55;
            padding: 8px 0;
            text-align: center;
            .course-icon {
                width: 30px;
                height: 30px;
            }
            .type-desc {
                font-size: 13px;
                color: #FFFFFF;
                line-height: 17px;
                margin-top: 2px;
            }
        }
    }

    .list-item-content {
        box-sizing: border-box;
        position: relative;
        padding: 12px 16px 16px;
        width: 100%;
        border-radius: 0px 0px 4px 4px;
        border-left: 1px solid #E4E9EE;
        border-right: 1px solid #E4E9EE;
        border-bottom: 1px solid #E4E9EE;
        .title {
            height: 48px;
            font-size: 16px;
            font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
            font-weight: bold;
            color: #222222;
            line-height: 24px;
            word-break: break-all;
            text-overflow: ellipsis;
            overflow: hidden;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
        }
        .course-info {
            font-size: 14px;
            color: #222222;
            line-height: 19px;
            margin-top: 16px;
            .teacher {
                max-width: 110px;
                color: #222222;
            }
            .teacher-label {
                color: var(--srt-color-gray);
            }
            .create-time {
                color: var(--srt-color-light-gray);
            }
        }
        
    }
}

:deep(.link-item){
    width:100%;
}
.no-data {
    margin-top: 50px;
}
</style>